

























































































import store from '../store'

export default {
  data () {
    return {
      title: 'Home'
    }
  },

  created: function () {
    store.state.activeTab = 'home'
  },

  store
}
